import React, { useContext } from 'react'
import { ThemeContext } from '../context/ThemeProvider';
import Style from "../css/body.module.scss"

export default function Body({ children }) {
    const { drawerSilde } = useContext(ThemeContext)

    return (
        <div className={drawerSilde ? Style.body_open : Style.body_close}>{children}</div>
    )
}
